export const KVS_ADMIN_USER_SETTINGS_KEY = "kvs.adminUserId";
export const KVS_KEEP_ORIGINAL_FILE_NAME_USER_SETTINGS_KEY = "kvs.keepOriginalFileName";

const KVS_FILE_NAME_REGEX = /^(..._){3}.._(..._){4}/;
export const normalizeKvsFileName = (fileName: string, filePrefix?: string): string => {
  if (KVS_FILE_NAME_REGEX.test(fileName)) { // remove "duplicate" data from file name
    fileName = fileName.replace(KVS_FILE_NAME_REGEX, "");
  }
  // always prepend the file prefix, regardless if we removed the "duplicate" data
  fileName = filePrefix ? `${filePrefix}_${fileName}` : fileName;
  return fileName;
};
